import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Icon } from '@iconify/react'
import SectionCard from '../shared/SectionCard'
import './style.css'
import { generator } from '@/utils/NumbersUtils'
import { Block } from '@/components/crRender'
import { Fragment } from 'react'
import ScalationDataRow from './DataRow'
import ActionBtn from '@/components/ActionBtn'

const createScalation = () => ({
    id: generator.key(),
    name: '',
    phoneNumber: '',
    email: '',
    diabled: '',
    waitedHours: null,
})

const EditScalations = ({ formHandler, providerInfo, isLoading }) => {

    const { t } = useTranslation()
    const [scalations, setScalations] = useState([...providerInfo?.escalations] || [])
    const { handleFormValues } = formHandler

    const addScalation = () => {
        const newScalation = createScalation()
        const updatedScalations = [...scalations, newScalation]
        setScalations(updatedScalations)
        handleFormValues('scalations', updatedScalations)
    }

    const removeScalation = (id) => {
        const updatedScalations = scalations.filter(scalation => scalation.id !== id)
        setScalations(updatedScalations)
        handleFormValues('scalations', updatedScalations)
    }

    const updateScalation = (id, field, value) => {
        const updatedScalations = scalations.map(scalation =>
            scalation.id === id ? { ...scalation, [field]: value } : scalation
        )
        setScalations(updatedScalations)
        handleFormValues('scalations', updatedScalations)
    }


    return (
        <SectionCard
            title={t("escalations")}
            icon="streamline:ai-technology-spark-remix"
            className="edit-scalations" >

            <div className="advanced-techs-container">
                <div className="scalations-header">
                    <ActionBtn
                        className="btn-primary add-scalation-btn m-0"
                        onApply={addScalation}
                        title={t("add-escalations")}
                        icon="mdi:plus-circle" />
                </div>
                <br />

                <div className="row ">

                    <Block isRender={scalations?.length > 0}>
                        {scalations?.map((scalation, index) =>
                            <Fragment key={`${scalation?.phoneNumber_index}`}>
                                <ScalationDataRow
                                    removeScalation={removeScalation}
                                    updateScalation={updateScalation}
                                    scalation={scalation} formHandler={formHandler} isLoading={isLoading} />
                            </Fragment>
                        )}
                    </Block>

                    <Block isRender={scalations.isEmpty()} className="empty-state col-md-12">
                        <Icon icon="mdi:robot-outline" className="empty-icon" />
                        <p>{t("no-scalations-added")}</p>
                        <p className="empty-hint">{t("click-add-scalation-to-start")}</p>
                    </Block>
            </div>
        </div>
            
        </SectionCard >
    )
}

export default EditScalations

